import type { UIMatch } from 'react-router-dom';

export type RouteCrumb = {
  label: string;
  to?: string;
};

type CrumbHandle = {
  crumb?: (match: unknown) => RouteCrumb | null;
};

export function collectRouteCrumbs(matches: UIMatch[]): RouteCrumb[] {
  const items: RouteCrumb[] = [];
  for (const m of matches) {
    const handle = m.handle as CrumbHandle | undefined;
    const c = handle?.crumb?.(m);
    if (c) {
      items.push(c);
    }
  }
  return items;
}
